@if (show) {
  <div style="display: flex; flex-direction: column">
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{ height: '30px', margin: '0' }"
    />
    <div style="display: flex; gap: 3px; align-items: start; width: 100%">
      @for (each of loaderItems(4); track each) {
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '15px', width: '10rem' }"
        />
      }
    </div>
  </div>
}
